/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AllowedAttributeValuesCreateRequest } from '../model/allowedAttributeValuesCreateRequest';
import { AllowedAttributeValuesDeleteRequest } from '../model/allowedAttributeValuesDeleteRequest';
import { AllowedAttributeValuesInformation } from '../model/allowedAttributeValuesInformation';
import { ErrorInformation } from '../model/errorInformation';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class AllowedAttributeValueService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createAllowedAttributeValues
     * Creates a list of allowed attribute values for an existing attribute value list.
     * @param allowedAttributeValuesCreateRequest the information needed to create the allowed attribute values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public allowedAttributeValueCreateAllowedAttributeValues(allowedAttributeValuesCreateRequest: AllowedAttributeValuesCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<AllowedAttributeValuesInformation>;
    public allowedAttributeValueCreateAllowedAttributeValues(allowedAttributeValuesCreateRequest: AllowedAttributeValuesCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AllowedAttributeValuesInformation>>;
    public allowedAttributeValueCreateAllowedAttributeValues(allowedAttributeValuesCreateRequest: AllowedAttributeValuesCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AllowedAttributeValuesInformation>>;
    public allowedAttributeValueCreateAllowedAttributeValues(allowedAttributeValuesCreateRequest: AllowedAttributeValuesCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (allowedAttributeValuesCreateRequest === null || allowedAttributeValuesCreateRequest === undefined) {
            throw new Error('Required parameter allowedAttributeValuesCreateRequest was null or undefined when calling allowedAttributeValueCreateAllowedAttributeValues.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<AllowedAttributeValuesInformation>(`${this.configuration.basePath}/allowedAttributeValues`,
            allowedAttributeValuesCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteAllowedAttributeValues
     * Deletes specified allowed attribute values from an existing attribute value list.
     * @param allowedAttributeValuesDeleteRequest the allowed attribute values delete request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public allowedAttributeValueDeleteAllowedAttributeValues(allowedAttributeValuesDeleteRequest: AllowedAttributeValuesDeleteRequest, observe?: 'body', reportProgress?: boolean): Observable<AllowedAttributeValuesInformation>;
    public allowedAttributeValueDeleteAllowedAttributeValues(allowedAttributeValuesDeleteRequest: AllowedAttributeValuesDeleteRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AllowedAttributeValuesInformation>>;
    public allowedAttributeValueDeleteAllowedAttributeValues(allowedAttributeValuesDeleteRequest: AllowedAttributeValuesDeleteRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AllowedAttributeValuesInformation>>;
    public allowedAttributeValueDeleteAllowedAttributeValues(allowedAttributeValuesDeleteRequest: AllowedAttributeValuesDeleteRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (allowedAttributeValuesDeleteRequest === null || allowedAttributeValuesDeleteRequest === undefined) {
            throw new Error('Required parameter allowedAttributeValuesDeleteRequest was null or undefined when calling allowedAttributeValueDeleteAllowedAttributeValues.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.delete<AllowedAttributeValuesInformation>(`${this.configuration.basePath}/allowedAttributeValues`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getAllowedAttributeValues
     * Retrieves a range of existing allowed attribute values.
     * @param namespace the namespace
     * @param attributeValueListName the attribute value list name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public allowedAttributeValueGetAllowedAttributeValues(namespace: string, attributeValueListName: string, observe?: 'body', reportProgress?: boolean): Observable<AllowedAttributeValuesInformation>;
    public allowedAttributeValueGetAllowedAttributeValues(namespace: string, attributeValueListName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AllowedAttributeValuesInformation>>;
    public allowedAttributeValueGetAllowedAttributeValues(namespace: string, attributeValueListName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AllowedAttributeValuesInformation>>;
    public allowedAttributeValueGetAllowedAttributeValues(namespace: string, attributeValueListName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling allowedAttributeValueGetAllowedAttributeValues.');
        }
        if (attributeValueListName === null || attributeValueListName === undefined) {
            throw new Error('Required parameter attributeValueListName was null or undefined when calling allowedAttributeValueGetAllowedAttributeValues.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<AllowedAttributeValuesInformation>(`${this.configuration.basePath}/allowedAttributeValues/namespaces/${encodeURIComponent(String(namespace))}/attributeValueListNames/${encodeURIComponent(String(attributeValueListName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
